import { registerFormInputComponent, addActionBarItem, addNavMenuItem, registerBulkAction, createBulkDeleteAction, DeletionResponse } from '@vendure/admin-ui/core';
import { ParcelProfileSelectorComponent } from './components/parcel-profile.components';
import { FulfillmentOptionsFormComponent } from './components/fulfillment-options-form.component';
import { Fulfillment } from '@vendure/admin-ui/core';
import { forkJoin, map, Observable, switchMap, take, tap } from 'rxjs';
import { ASSIGN_PARCEL_PROFILE_TO_CHANNELS, DELETE_PARCEL_PROFILE, REMOVE_PARCEL_PROFILE_FROM_CHANNELS } from './components/gql/parcel-profile.graphql';
import { ID } from '@vendure/core';
import { bulkActionIsDefaultChannel, channelAction } from '../common/ui/utils';
import { DimensionInputComponent } from './components/dimension-input-form.component';

const deleteParcelProfilesBulkAction = createBulkDeleteAction(
    {
        location: 'parcel-profile-list',
        requiresPermission: 'DeleteParcelProfile',
        getItemName: (item:any) => item.name,
        bulkDelete: (
            dataService,
            ids: ID[],
            _retrying?: boolean,
          ): Observable<DeletionResponse[]> => {
            const deletes$ = ids.map(id =>
              dataService
                .mutate(DELETE_PARCEL_PROFILE, { id })
                .pipe(map((res: any) => res.deleteParcelProfile as DeletionResponse)),
            );
            return forkJoin(deletes$);
        },
    },
);

export default [
    registerFormInputComponent('parcel-profile-selector', ParcelProfileSelectorComponent),
    registerFormInputComponent('fulfillment-options-form', FulfillmentOptionsFormComponent),
    registerFormInputComponent('dimension-form-input', DimensionInputComponent),
    addActionBarItem({
        id: 'order-fulfillment-print-label',
        label: 'Print Label',
        locationId: 'order-detail',
        icon: 'printer',
        buttonState: context => {
            return context.route.data.pipe(
                switchMap(data => data.detail.entity),
                map((order: any) => {
                    console.log(order);
                    const isPending = order.fulfillments?.some((fulfillment: Fulfillment) => fulfillment.state === 'Pending' && fulfillment.customFields.labelUrl);
                    return {
                        disabled: isPending === false,
                        visible: true,
                    };
                }),
            );
        },
        onClick: async (event, context) => {
            try {
                context.entity$.pipe(
                    take(1),
                    tap((order: any) => {
                        if (order) {
                            const fulfillment = order.fulfillments?.find((fulfillment: Fulfillment) => fulfillment.state === 'Pending');
                            if (fulfillment?.customFields.labelUrl) {
                                window.open(fulfillment.customFields.labelUrl, '_blank');
                            }
                        }
                    }),
                ).subscribe();
            } catch (error: any) {
                context.notificationService.error('Failed to print label: ' + error.message);
            }
        },
    }),
    registerBulkAction(deleteParcelProfilesBulkAction),
    registerBulkAction({
        isVisible: (context) => bulkActionIsDefaultChannel(context),
        location: 'parcel-profile-list',
        label: 'Delete From Channels',
        icon: 'trash',
        requiresPermission: 'UpdateParcelProfile',
        onClick: async (context) =>
            channelAction(
                context,
                'remove',
                'Parcel Profile Options',
                REMOVE_PARCEL_PROFILE_FROM_CHANNELS
            )
    }),
    registerBulkAction({
        isVisible: (context) => bulkActionIsDefaultChannel(context),
        location: 'parcel-profile-list',
        label: 'Assign To Channel',
        icon: 'plus',
        requiresPermission: 'UpdateParcelProfile',
        onClick: async (context) =>
            channelAction(
                context,
                'assign',
                'Parcel Profile Options',
                ASSIGN_PARCEL_PROFILE_TO_CHANNELS
            )
    })
];



